import React, { useState } from 'react';

const InfoButtonWithPopover = ({ infoText }) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);

  return (
    <div className="relative inline-block">
      {/* Botón de Información */}
      <button
        className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
        onClick={() => setIsPopoverVisible(!isPopoverVisible)}
        onMouseEnter={() => setIsPopoverVisible(true)}
        onMouseLeave={() => setIsPopoverVisible(false)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </button>

      {/* Popover */}
      {isPopoverVisible && (
        <div
          className="absolute z-10 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg p-3 text-sm text-gray-700"
          style={{ top: '100%', left: '50%', transform: 'translateX(-50%)' }}
        >
          {infoText}
        </div>
      )}
    </div>
  );
};

export default InfoButtonWithPopover;